import { Component, ErrorInfo, ReactNode } from "react";

type Props = { children: ReactNode };
type State = { hasError: boolean; message?: string; stack?: string };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(err: any): State {
    return { hasError: true, message: String(err?.message || err), stack: String(err?.stack || "") };
  }
  componentDidCatch(error: any, info: ErrorInfo) {
    // keeps it visible in console too
    console.error("Global ErrorBoundary", { error, info });
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{padding:16,fontFamily:"sans-serif"}}>
        <h1>Something went wrong</h1>
        <p style={{whiteSpace:"pre-wrap"}}>{this.state.message}</p>
        <details open style={{whiteSpace:"pre-wrap", marginTop:8}}>
          <summary>Stack</summary>
          {this.state.stack}
        </details>
      </div>
    );
  }
}

